import http from '../../../utils/fetch';
import updownfile from '../../../utils/updownfile';
export default {

    baseUrl:"/api/swyl/v1/cost/bscCost",

    //添加新费用使用条目
    insert(q){
        return http({
            url: this.baseUrl + '/insert',
            method: 'post',
            params: q
        });
    },

    updateById(q){
        return http({
            url: this.baseUrl + '/updateById',
            method: 'post',
            params: q
        });
    },

    selectById(q){
        return http({
            url: this.baseUrl + '/selectById',
            method: 'post',
            params: q
        });
    },

}